import React from "react";

import PhoneMockup from "../../Assets/mobile-ap.png";
import AppleBadge from "../../Assets/apple.svg";
import GoogleBadge from "../../Assets/google.svg";
import MicrosoftBadge from "../../Assets/micro.svg";
import IMacBadge from "../../Assets/imac.svg";

function HeroSection() {
  
  return (

    <div className="grid grid-cols-1 lg:grid-cols-2 lg:space-x-64 justify-center items-center flex-col md:flex-row text-center md:text-center w-full my-16 2xl:mt-20 xl:mt-20 lg:mt-20  md:my-32 px-8 md:px-32 ">
      <div className="">
        <h2 className="text-[40px] md:text-[56px] dark:text-white capitalize leading-[46px] md:leading-[64px] font-bold">
          Fix your
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#0CC8E8] to-[#2DEEAA]">
            {" "}
            Speech{" "}
          </span>
          with AI Powered therapists
        </h2>
        <p className="my-4 text-[14px] text-center lg:text-center  tracking-tighter lg:tracking-normal lg:text-[16.5px] text-[#111920] dark:text-white">
          Discover the future of speech therapy with IzzyAI. Our cutting-edge AI
          therapists are designed to understand, guide, and enhance your speech
          capabilities, offering a personalized path to clearer communication.
        </p>
        {/* <Button>Learn More</Button> */}
        <p className="my-4 block bg-clip-text text-transparent font-bold text-[30px] bg-gradient-to-r from-[#0CC8E8] to-[#2DEEAA]">
              Coming Soon On{" "}
            </p>
        <div className="flex justify-center space-x-2 flex-nowrap md:space-x-1 md:flex-nowrap lg:flex-nowrap  lg:space-x-2 items-center ">
        
          <a href="#">
            <img src={GoogleBadge} 
            alt="IzzyAi app in Google Play"
            width={"auto"}
            height={"auto"}
            loading="lazy"
             />
          </a>
          <a href="#">
            <img 
            src={AppleBadge} 
            alt="IzzyAi app in Apple Store"
            width={"auto"}
            height={"auto"}
             />
          </a>
          <a href="#">
            <img
              className="border rounded-md border-black dark:border-none"
              src={IMacBadge}
              alt="IzzyAi app in iMac"
              width={"auto"}
              height={"auto"}
            />
          </a>
          <a href="#">
            <img
              className="border rounded-md border-black dark:border-none"
              src={MicrosoftBadge}
              alt="IzzyAi app in Microsoft"
              width={"auto"}
              height={"auto"}
            />
          </a>
         
        </div>
      </div>
      <div className="flex justify-center lg:flex-none lg:justify-normal  p-4 ">
        <img
          className="w-fit h-full md:max-h-[450px] lg:max-h-[450px]"
          src={PhoneMockup}
          alt="Doing IzzyAi Speech Exercise"
          width={"auto"}
          height={"auto"}
        />
      </div>
    </div>
  );
}

export default HeroSection;
